"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMakeOfferCoBuyerDto = instanceOfMakeOfferCoBuyerDto;
exports.MakeOfferCoBuyerDtoFromJSON = MakeOfferCoBuyerDtoFromJSON;
exports.MakeOfferCoBuyerDtoFromJSONTyped = MakeOfferCoBuyerDtoFromJSONTyped;
exports.MakeOfferCoBuyerDtoToJSON = MakeOfferCoBuyerDtoToJSON;
exports.MakeOfferCoBuyerDtoToJSONTyped = MakeOfferCoBuyerDtoToJSONTyped;
/**
 * Check if a given object implements the MakeOfferCoBuyerDto interface.
 */
function instanceOfMakeOfferCoBuyerDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function MakeOfferCoBuyerDtoFromJSON(json) {
    return MakeOfferCoBuyerDtoFromJSONTyped(json, false);
}
function MakeOfferCoBuyerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'name': json['name'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}
function MakeOfferCoBuyerDtoToJSON(json) {
    return MakeOfferCoBuyerDtoToJSONTyped(json, false);
}
function MakeOfferCoBuyerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
    };
}
